module.exports = __webpack_public_path__ + "img/kommune-415.dfbe55a3.svg";